var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-container"
  }, [_vm.errorText ? _c('div', {
    staticClass: "errors-container"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorText))])]) : _vm._e(), _c('div', {
    staticClass: "section-container"
  }, [_c('substrate-mount', [_c('div', {
    staticClass: "option-container"
  }, [_c('option-panel', {
    attrs: {
      "option": _vm.formattedCountry,
      "noactive": ""
    },
    on: {
      "click": _vm.onShownCountriesModal
    }
  }, [_c('cs-button', {
    attrs: {
      "type": "secondary"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.change')) + " ")])], 1)], 1), _vm.isCountryUzbekistan ? _c('div', {
    staticClass: "identification-myid"
  }, [_c('p', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 20,
      expression: "20"
    }],
    domProps: {
      "textContent": _vm._s(_vm.$t('indentification.form.uzbekistan.title'))
    }
  }), _c('base-button', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 20,
      expression: "20"
    }],
    on: {
      "click": _vm.handleRedirectToMyId
    }
  }, [_c('img', {
    attrs: {
      "src": require("images/logos/logo-myid.svg"),
      "alt": ""
    }
  })]), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('indentification.form.uzbekistan.description'))
    }
  })], 1) : _vm._e(), _c('a', {
    staticClass: "information-link-container",
    attrs: {
      "href": "https://help.capusta.space/identification",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('how.fill.form.correctly')))]), _c('i')]), _c('div', {
    staticClass: "input-container"
  }, [_c('input-text', {
    ref: "secondName",
    attrs: {
      "input-id": "input-secondname",
      "input-name": _vm.$t('second.name'),
      "input-placeholder": _vm.$t('for.example.second.name'),
      "min-length": 2,
      "max-length": 255,
      "required": ""
    },
    model: {
      value: _vm.form.secondName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "secondName", $$v);
      },
      expression: "form.secondName"
    }
  })], 1), _c('div', {
    staticClass: "input-container"
  }, [_c('input-text', {
    ref: "firstName",
    attrs: {
      "input-id": "input-firstname",
      "input-name": _vm.$t('first.name'),
      "input-placeholder": _vm.$t('for.example.first.name'),
      "min-length": 2,
      "max-length": 255,
      "required": ""
    },
    model: {
      value: _vm.form.firstName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "firstName", $$v);
      },
      expression: "form.firstName"
    }
  })], 1), _c('div', {
    staticClass: "input-container"
  }, [_c('input-text', {
    attrs: {
      "input-id": "input-patronymic",
      "input-name": _vm.$t('third.name'),
      "input-placeholder": _vm.$t('for.example.third.name'),
      "required": false
    },
    model: {
      value: _vm.form.patronymic,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "patronymic", $$v);
      },
      expression: "form.patronymic"
    }
  })], 1), _c('div', {
    staticClass: "input-container"
  }, [_c('cs-input-validation', {
    key: "input-birth-date",
    attrs: {
      "value": _vm.form.birthDate,
      "validation-rules": {
        date: {
          min: 14,
          max: 100
        },
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var error = _ref.error;
        return [_c('input-text', {
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: '##.##.####',
            expression: "'##.##.####'"
          }],
          key: "input-birth-date",
          ref: "birthDate",
          attrs: {
            "error": error,
            "input-id": "input-birth-date",
            "input-name": _vm.$t('birth.date'),
            "input-placeholder": _vm.$t('date.abbreviated'),
            "required": ""
          },
          model: {
            value: _vm.form.birthDate,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "birthDate", $$v);
            },
            expression: "form.birthDate"
          }
        })];
      }
    }])
  })], 1), _c('div', {
    staticClass: "input-container"
  }, [_c('input-text', {
    attrs: {
      "input-id": "input-place-of-birth",
      "input-name": _vm.$t('birth.place'),
      "input-placeholder": _vm.$t('for.example.birth.place'),
      "min-length": 2,
      "max-length": 255,
      "required": ""
    },
    model: {
      value: _vm.form.placeOfBirth,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "placeOfBirth", $$v);
      },
      expression: "form.placeOfBirth"
    }
  })], 1), _vm.passport ? _c('div', {
    staticClass: "input-container"
  }, [_c('cs-input-validation', {
    key: "input-document-id-validation",
    attrs: {
      "value": _vm.form.documentId,
      "validation-rules": {
        passport: _vm.passport,
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var error = _ref2.error;
        return [_c('input-text', {
          key: "input-document-id",
          ref: "documentId",
          attrs: {
            "error": error,
            "input-id": "input-document-id",
            "input-name": _vm.$t(_vm.passport.label),
            "input-placeholder": _vm.passport.placeholder,
            "min-length": 2,
            "max-length": 255,
            "data-private": "",
            "required": ""
          },
          model: {
            value: _vm.form.documentId,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "documentId", $$v);
            },
            expression: "form.documentId"
          }
        })];
      }
    }], null, false, 2892524554)
  })], 1) : _vm._e(), _c('div', {
    staticClass: "input-container"
  }, [_c('cs-input-validation', {
    key: "input-document-issue-date-validation",
    attrs: {
      "value": _vm.form.documentIssueDate,
      "validation-rules": {
        date: {
          min: -1,
          max: 100
        },
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var error = _ref3.error;
        return [_c('input-text', {
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: '##.##.####',
            expression: "'##.##.####'"
          }],
          key: "input-document-issue-date",
          ref: "documentIssueDate",
          attrs: {
            "error": error,
            "input-id": "input-document-issue-date",
            "input-name": _vm.$t('passport.issue.date'),
            "input-placeholder": _vm.$t('date.abbreviated'),
            "required": ""
          },
          model: {
            value: _vm.form.documentIssueDate,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "documentIssueDate", $$v);
            },
            expression: "form.documentIssueDate"
          }
        })];
      }
    }])
  })], 1), _vm.isShownInsuranceNumber ? _c('div', {
    staticClass: "input-container"
  }, [_c('input-text', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '###-###-### ##',
      expression: "'###-###-### ##'"
    }],
    attrs: {
      "input-id": "input-insurance-number",
      "input-name": _vm.$t('common.snils'),
      "input-placeholder": "128-501-988 88",
      "min-length": 14,
      "max-length": 14,
      "data-private": "",
      "required": ""
    },
    model: {
      value: _vm.form.insuranceNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "insuranceNumber", $$v);
      },
      expression: "form.insuranceNumber"
    }
  })], 1) : _vm._e()])], 1), _c('div', {
    staticClass: "button-primary-container"
  }, [_c('cs-button', {
    attrs: {
      "disabled": !_vm.isValidForm
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('provide.information')) + " ")])], 1), _c('cs-dialog', {
    model: {
      value: _vm.isShownCountries,
      callback: function callback($$v) {
        _vm.isShownCountries = $$v;
      },
      expression: "isShownCountries"
    }
  }, [_c('dialog-list-layout', _vm._l(_vm.formattedCountries, function (country) {
    return _c('option-panel', {
      key: country.id,
      attrs: {
        "option": country
      },
      on: {
        "click": _vm.onSelectCountry
      }
    });
  }), 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }